<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <!-- <el-col>
          <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
        </el-col> -->
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%"> -->
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              height="73vh"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="商家名称" align="center" prop="商家名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="预定单号" align="center" prop="预定单号">
                <template slot-scope="scope">
                  <span>{{ scope.row.reserveNo }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="预定关联订单号" align="center"  prop="预定关联订单号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderNumber }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="预定时间" align="center" prop="预定时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.reserveTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="桌台区域名称"
                align="center"
                prop="桌台区域名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.tableAreaName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="预定桌台编码" align="center"  prop="预定桌台编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="预定桌台名称"
                align="center"
                prop="预定桌台名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.tableName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="预定桌台数量"
                align="center"
                prop="预定桌台数量"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.tableNum }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="预定人数" align="center" prop="预定人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.personNum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="预定人" align="center" prop="预定人">
                <template slot-scope="scope">
                  <span>{{ scope.row.booker }}</span>
                </template>
              </el-table-column>
              <el-table-column label="性别" align="center" prop="1：先生">
                <template slot-scope="scope">
                  <span v-if="scope.row.bookerType == 1">先生</span>
                  <span v-if="scope.row.bookerType == 2">女士</span>
                </template>
              </el-table-column>
              <el-table-column label="预定电话" align="center" prop="预定电话">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="是否收取定金"
                align="center"
                prop="是否收取定金"
              >
                <template slot-scope="scope">            
                  <el-tag v-if="scope.row.isDeposit == 1" type="success">已收取</el-tag>
                  <el-tag v-if="scope.row.isDeposit == 0" type="danger">未收取</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="定金金额" align="center" prop="定金金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.depositAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="是否点餐" align="center" prop="是否点餐">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.isOrderDishes }}</span> -->
                  <span v-if="scope.row.isOrderDishes == 1">已点餐</span>
                  <span v-if="scope.row.isOrderDishes == 0">未点餐</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" prop="状态">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.state }}</span> -->
                  <span v-if="scope.row.state == 0">未到店</span>
                  <span v-if="scope.row.state == 1">已到店</span>
                  <span v-if="scope.row.state == 2">取消预定</span>
                </template>
              </el-table-column>
              <el-table-column label="到店时间" align="center" prop="到店时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.arrivalDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="预定的日期"
                align="center"
                prop="预定的日期"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.reserveDay }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="预定的具体时间"
                align="center"
                prop="预定的具体时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.reserveHourMinute }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="预定的周几"
                align="center"
                prop="预定的周几"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.reserveWeek }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="备注" align="center" prop="备注">
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">

                  <el-button v-if="scope.row.isOrderDishes == 1"
                    type="text"
                    style="padding:0;"
                    @click="openDialogDetail(scope.row.reserveNo)"
                    >查看菜品</el-button
                  >
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip> -->
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip> -->
                </template>
              </el-table-column>
            </el-table>
          <!-- </el-row></el-scrollbar
        >
      </div> -->
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 明细弹窗 -->
    <el-dialog title="明细" :visible.sync="dialogDetails" width="1000px">
      <div>
        <el-table
          :data="detailsData"
          style="width:100%"
          border
          fit
          :height="height"
          highlight-current-row
          @sort-change="sortChange"
        >
          <el-table-column label="商家名称" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.merchantName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品类名称" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.num }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="消费金额" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.costSum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="消费时间"
            align="center"
            prop="date"
            width="180"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.orderTime | dataFormat }}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDetails = false">取消</el-button>
        <el-button @click="dialogDetails = false" type="primary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      dialogDetails: false,
      detailsData: [],
      reserveNo: ""
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantReserve/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantReserves/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantReserves/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    openDialogDetail(reserveNo) {
      var that = this;
      that.dialogDetails = true;
      let tableListe = [];
      tableListe = that.tableData;
      that.reserveNo = reserveNo;
      if (tableListe) {
        tableListe.forEach(e => {
          if (e.reserveNo == reserveNo) {
            if (e.productList) {
              that.detailsData = e.productList;
              console.log("详情列表-----", that.detailsData);
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
.managingPeople .el-card{
  height: 90vh;
}
</style>
